import React, { useState } from 'react';
import './styling/BookingSystem.css';

const BookingSystem = () => {
  // Define the court categories with counts and labels.
  const courtCategories = [
    { id: 'indoor', name: 'Indoor Courts', count: 7, label: 'Indoor Court' },
    { id: 'mini', name: 'Mini Courts', count: 2, label: 'Mini Court' },
    { id: 'padel', name: 'Padel Courts', count: 3, label: 'Padel Court' },
    { id: 'outdoor', name: 'Outdoor Courts', count: 11, label: 'Outdoor Court' }
  ];

  // Include an "All Courts" filter in addition to individual types.
  const filters = [
    { id: 'all', name: 'All Courts' },
    ...courtCategories.map(cat => ({ id: cat.id, name: cat.name }))
  ];

  // State for the selected filter (default is "all").
  const [selectedFilter, setSelectedFilter] = useState('all');

  // Define timeslots from 8:00 to 16:00 (9 slots total).
  const timeslotHours = Array.from({ length: 9 }, (_, i) => 8 + i);

  // Generate court data based on the selected filter.
  const generateCourtData = () => {
    let courts = [];
    if (selectedFilter === 'all') {
      courtCategories.forEach(cat => {
        for (let i = 1; i <= cat.count; i++) {
          courts.push({
            id: `${cat.id}-${i}`,
            courtName: `${cat.label} ${i}`,
            timeslots: Array.from({ length: timeslotHours.length }, () => Math.random() > 0.5)
          });
        }
      });
    } else {
      const category = courtCategories.find(cat => cat.id === selectedFilter);
      for (let i = 1; i <= category.count; i++) {
        courts.push({
          id: `${category.id}-${i}`,
          courtName: `${category.label} ${i}`,
          timeslots: Array.from({ length: timeslotHours.length }, () => Math.random() > 0.5)
        });
      }
    }
    return courts;
  };

  const courts = generateCourtData();

  return (
    <div className="booking-system">
      <h1>Tennis Center Booking</h1>

      {/* Filter Tabs */}
      <div className="filter-tabs">
        {filters.map(filter => (
          <button
            key={filter.id}
            className={`tab ${selectedFilter === filter.id ? 'active' : ''}`}
            onClick={() => setSelectedFilter(filter.id)}
          >
            {filter.name}
          </button>
        ))}
      </div>

      {/* Availability Grid */}
      <div className="table-container">
        <table className="availability-table">
          <thead>
            <tr>
              {/* Empty header cell for the times column */}
              <th className="time-header"></th>
              {courts.map(court => (
                <th key={court.id}>{court.courtName}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {timeslotHours.map((hour, rowIndex) => (
              <tr key={rowIndex}>
                {/* Times displayed as a range */}
                <td className="time-label">{`${hour}:00 - ${hour + 1}:00`}</td>
                {courts.map(court => (
                  <td 
                    key={court.id}
                    className={`timeslot ${court.timeslots[rowIndex] ? 'available' : 'booked'}`}
                  >
                    {court.timeslots[rowIndex] ? 'Free' : 'Booked'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BookingSystem;
